'use strict';

module.exports.fundQuoteGrid = function () {
    const yearToDatePct = "data.shareInfo.pricechange.yeartodatepct | numeraljs '0.00' | postFix '%'";
    const day30Pct = "data.shareInfo.pricechange.day30pct | numeraljs '0.00' | postFix '%'";
    const day90Pct = "data.shareInfo.pricechange.day90pct | numeraljs '0.00' | postFix '%'";
    const weeks52Change = "data.shareInfo.priceinfo.weeks52change | numeraljs '0.00' | postFix '%'";
    const year3change = "data.shareInfo.priceinfo.year3change | numeraljs '0.00' | postFix '%'";
    const year5change = "data.shareInfo.priceinfo.year5change | numeraljs '0.00' | postFix '%'";
    const year10change = "data.shareInfo.priceinfo.year10change | numeraljs '0.00' | postFix '%'";

    return `
        <div rv-if="data.datatype | or 'mutual fund' 'money market fund'">
            <div class="pure-g">
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-l">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-last"
                            rv-if="data.pricedata.last"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.last| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.last | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-change"
                            rv-if="data.pricedata.change"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.change| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.change | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-changepercent"
                            rv-if="data.pricedata.changepercent"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.changepct| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-html="data.pricedata.changepercent | numeraljs '0.00' | postFix '%'"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-prevclose"
                            rv-if="data.pricedata.prevclose"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.prevclose| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.prevclose | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-weeks52high"
                            rv-if="data.shareInfo.priceinfo.weeks52high"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.yearhigh| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.shareInfo.priceinfo.weeks52high | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-weeks52low"
                            rv-if="data.shareInfo.priceinfo.weeks52low"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.yearlow| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.shareInfo.priceinfo.weeks52low | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-exShName"
                            rv-if="data.key.exShName"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.exchange| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-tooltip"
                                        rv-title="data.key.exLgName"
                                        rv-on-mouseenter="data.qmtooltip"
                                        rv-text="data.key.exShName"
                                    >
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-r">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-yeartodatepct"
                            rv-if="data.shareInfo.pricechange.yeartodatepct"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.ytd| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" rv-html="${yearToDatePct}"></div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-day30pct"
                            rv-if="data.shareInfo.pricechange.day30pct"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.1mnth| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" rv-html="${day30Pct}"></div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-day90pct"
                            rv-if="data.shareInfo.pricechange.day90pct"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.3mnths| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" rv-html="${day90Pct}"></div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-weeks52change"
                            rv-if="data.shareInfo.priceinfo.weeks52change"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.1yr| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" rv-html="${weeks52Change}"></div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-year3change"
                            rv-if="data.shareInfo.priceinfo.year3change"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.3yr| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" rv-html="${year3change}"></div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-year5change"
                            rv-if="data.shareInfo.priceinfo.year5change"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.5yr| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" rv-html="${year5change}"></div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-year10change"
                            rv-if="data.shareInfo.priceinfo.year10change"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.10yr| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" rv-html="${year10change}"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};
